import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Avatar, Typography, Spin, Button, Modal, Select } from 'antd';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import TextEvents from 'app/components/TextEvents';
import { useStyles, styles } from './KardexScreenStyles';
import KardexContainer from './KardexContainer/KardexContainer';
import { useDispatch, useSelector } from 'react-redux';
import { exportKardexXls, exportKardexBookmark } from 'app/actions/UserSearchActions';
import { CSVLink } from "react-csv";
import './KardexScreenStyle.css'


import TextInput from 'app/components/TextInput';
import { employeeById } from 'app/reducers';
import TechnicalRepresentativeContainer from 'app/containers/TechnicalRepresentativeContainer';

const { Title } = Typography;
const { Option } = Select;

export default function KardexScreen(props) {

    const classes = useStyles();
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [filterKardex, setFilterKardex] = useState({});
    const dispatch = useDispatch();
    const [rowsSelected, setRowSelected] = useState([]);
    const [selectedCommunication, setSelectedCommunication] = useState([]);
    const employeeData = useSelector(employeeById)
    const [openModal, setOpenModal] = useState(false);
    const [revisor, setRevisor] = useState("");
    const [prePayload, setPrePayload] = useState(undefined);
    const {
        listKardex
    } = useSelector(state => state.UserSearchReducer);

    //Datos del store de redux
    const {
        isExportingKardexXls,
        isExportingKardexBookmarkXls
    } = useSelector(state => state.UserSearchReducer);

    const exportGenerate = (payload) => {
        let result = selectedCommunication.map(a => `${a.idCommunicationProgram}|${a.idCommunication}`);

        dispatch(exportKardexBookmark({
            employeeId: props.employeeId,
            LstIdCommunicationProgram: result,
            elaborador: `${employeeData.firstName} ${employeeData.lastName}`,
            revisor: revisor
        }, `${props.employeeId}`));

        setOpenModal(false);
        setRevisor("");
    }

    const exportSingleGenerate = (payload) => {
        setPrePayload(payload);
        setOpenModal(true);
    }

    const exportSingleGenerate_ = () => {
        dispatch(exportKardexBookmark({
            EmployeeId: props.employeeId,
            LstIdCommunicationProgram: prePayload.idCommunicationProgram,
            elaborador: `${employeeData.firstName} ${employeeData.lastName}`,
            revisor: revisor
        }, `${props.employeeId}`));
        setOpenModal(false);
        setRevisor("");
        setPrePayload(undefined);
    }

    const checkExportType = (type) => {
        if (prePayload == undefined) {
            exportGenerate("");
        } else {
            exportSingleGenerate_();
        }
    }


    const showModalFunc = () => {
        Modal.info({
            title: 'Error',
            content: (
                <div>
                    <p>¡No se puede generar el reporte de evidencias! Todos los comunicados deben tener estatus aprobado</p>
                </div>
            ),
            onOk() {
                Modal.destroyAll();
            },
        });
    }

    function indexOfExt(list, item) {
        if(item.hasOwnProperty('key'))
        delete item.key;


        var len = list.length;
    
        for (var i = 0; i < len; i++) {
            var keys = Object.keys(list[i]);
            var flg = true;
            for (var j = 0; j < keys.length; j++) {
                var value = list[i][keys[j]];
                if (item[keys[j]] !== value) {
                    flg = false;
                }
            }
            if (flg == true) {
                return i;
            }
        }
        return -1;
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
           let selectedCurrent = [...selectedCommunication];
           let gridCurrent = [...listKardex];

           //delete
           if(selectedRows.length == 0){
            for(let index in  listKardex){
                let posicion = indexOfExt(selectedCurrent,listKardex[index]);
                if(posicion >= 0)
                selectedCurrent.splice(posicion,1);
            }
           }
           else
           {

            for(let index in  selectedRows){
                let posicion = indexOfExt(selectedCurrent,selectedRows[index]);
                let posicionGrid = indexOfExt(gridCurrent,selectedRows[index]);
                
                //Add
                if (posicion < 0) 
                    selectedCurrent.push(selectedRows[index]);
                
                //Delete
                if(posicionGrid >= 0)
                    gridCurrent.splice(posicionGrid,1);

               }

               //remove
               for(let index in  gridCurrent){
                let posicion = indexOfExt(selectedCurrent,gridCurrent[index]);
                if(posicion >= 0)
                    selectedCurrent.splice(posicion,1);
               }
           }

           setSelectedCommunication(selectedCurrent);
        },
        getCheckboxProps: record => ({
            disabled: (record.statusName != "Aprobado" || record.trainingName != "Disciplina Operacional"), // Column configuration not to be checked
        }),
    };

    //Accion clic de botón exportar
    const exportXls = (NameEmployee) => {
        const f = filterKardex;
        dispatch(exportKardexXls({
            employeeId: props.employeeId,
            nameEmployee: NameEmployee,
            courseCode: f.courseCode != undefined ? f.courseCode.length > 0 ? f.courseCode[0] : null : null,
            courseName: f.courseName != undefined ? f.courseName.length > 0 ? f.courseName[0] : null : null,
            communicationProgramName: f.communicationProgramName != undefined ? f.communicationProgramName.length > 0 ? f.communicationProgramName[0] : null : null,
            trainingName: f.trainingName != undefined ? f.trainingName.length > 0 ? f.trainingName[0] : null : null,
            especialtyOrSystem: f.especialtyOrSystem != undefined ? f.especialtyOrSystem.length > 0 ? f.especialtyOrSystem[0] : null : null,
            contractName: f.contractName != undefined ? f.contractName.length > 0 ? f.contractName[0] : null : null,
            ot: f.ot != undefined ? f.ot.length > 0 ? f.ot[0] : null : null,
            statusName: f.statusName != undefined ? f.statusName.length > 0 ? f.statusName[0] : null : null,
            diffusionStartDate: f.diffusionStartDate != undefined ? f.diffusionStartDate.length > 0 ? f.diffusionStartDate[0] : null : null,
            diffusionEndDate: f.diffusionEndDate != undefined ? f.diffusionEndDate.length > 0 ? f.diffusionEndDate[0] : null : null,
            dateTest: f.dateTest != undefined ? f.dateTest.length > 0 ? f.dateTest[0] : null : null,
            dateCT: f.dateCT != undefined ? f.dateCT.length > 0 ? f.dateCT[0] : null : null,
            destResult: f.destResult != undefined ? f.destResult.length > 0 ? f.destResult[0] : null : null,
            dateNotify: f.dateNotify != undefined ? f.dateNotify.length > 0 ? f.dateNotify[0] : null : null,
            sortColumn: sorter.field != undefined ? sorter.field : '',
            sortDir: sorter.order != undefined ? sorter.order === "ascend" ? "ASC" : "DESC" : ''
        }));
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    const findTechnical = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.technical[values[i]].idResponsible;
            params.technical.forEach((v) => {
                if (v.idResponsible === id) {
                    temp.push(v);
                }
            });
        }
        setRevisor(temp[0].responsibleName);
    }

    const SelectItem = (name = [], value) => {
        if (name == null) name = [];
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    return (
        <div className={classes.root}>

            <Modal
                title="Nombre del Revisor del documento (Representante técnico)"
                visible={openModal}
                onOk={() => checkExportType()}
                onCancel={
                    () => {
                        setOpenModal(false);
                        setRevisor("");
                        setPrePayload(undefined);
                    }}
                okText="Generar"
                cancelText="Cancelar"
                okButtonProps={{ disabled: revisor == "" }}
            >
                <TechnicalRepresentativeContainer>
                    {(params) => {
                        return (

                            <TextInput
                                text=''
                                color='darker'
                                size='label'
                                weight='medium'
                                placeholder='Selecciona revisor'
                                style={styles.inputSelect}
                                showSearch
                                onChange={(v) => {
                                    findTechnical(params, v);
                                }}
                            >
                                {SelectItem(params.technical, 'responsibleName')}
                            </TextInput>
                        )
                    }}
                </TechnicalRepresentativeContainer>
            </Modal>
         
            <KardexContainer
                idEmployee={props.employeeId}
                classes={classes}
                sorter={sorter}
                setSorter={setSorter}
                filterKardex={filterKardex}
                setFilterKardex={setFilterKardex}
                pagination={pagination}
                setPagination={setPagination}
                exportSingleGenerate={exportSingleGenerate}
            >
                {(params) => {
                    return Object.keys(params.communicationProgram.employeeData).length > 1 ?
                        <div className={`${classes.content}`}>
                            <div /*className={classes.appBarSpacer}*/ />
                            <div elevation={0} style={styles.titleBox}>
                                <Breadcrumbs aria-label="Breadcrumb">
                                    Estatus de Comunicación
                                    <TextEvents
                                        text={`Estatus de comunicación por persona`}
                                        color="cotemar"
                                        size='subtitle'
                                        weight="bold"
                                    />
                                </Breadcrumbs>
                            </div>
                            <div style={styles.baseVerticalMargin}>
                                <Card className={classes.tabContainer}>
                                    <Row>
                                        <Col span={8} offset={6}>
                                            <Title level={3}> {params.communicationProgram.employeeData.EmployeeName} ({props.isExternal ? props.externalUserName : props.employeeId})</Title>
                                            {!props.isExternal ? params.communicationProgram.employeeData.CategoryName : null}
                                            {!props.isExternal ? <br /> : null}
                                            {props.isExternal ? 'Colaborador Externo' : 'Colaborador Interno'}
                                        </Col>
                                        <Col span={4} offset={4}>
                                            <Avatar size={100} src={params.communicationProgram.employeeData.UrlAvatar} icon="user" />
                                        </Col>
                                    </Row>
                                </Card>
                            </div>

                            <Row justify="end">
                                {/* <Col offset={20} span={2}>
                                    <Button
                                        className={classes.button}
                                        loading={isExportingKardexXls}
                                        variant="contained"
                                        type="primary"
                                        onClick={() => exportXls(params.communicationProgram.employeeData.EmployeeName)}
                                    >
                                        Exportar
                                    </Button>
                                </Col> */}
                                <Col offset={21} span={3}>
                                    <Button
                                        className={classes.button}
                                        loading={isExportingKardexXls}
                                        variant="contained"
                                        type="primary"
                                        onClick={() => exportXls(params.communicationProgram.employeeData.EmployeeName)}
                                    >
                                        Exportar
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        loading={isExportingKardexBookmarkXls}
                                        disabled={selectedCommunication.length === 0}
                                        onClick={() => setOpenModal(true)}
                                    >
                                        Generar
                                    </Button>
                                    {/* {!params.isFiltering ? (<div className={classes.container} style={styles.baseVerticalMargin}>
                                        <Button
                                            className={classes.button}
                                            loading={isExportingKardexXls}
                                            variant="contained"
                                            type="primary"
                                            onClick={() => exportXls(params.communicationProgram.employeeData.EmployeeName)}
                                        >
                                            Exportar
                                        </Button>
                                    </div>)
                                        :
                                        (<div className={classes.container} style={styles.baseVerticalMargin}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="primary"
                                            >
                                                <CSVLink
                                                    data={params.dataToExport} headers={params.columnsExport}
                                                    filename={"ComunicacionesPorPersona.csv"}
                                                    className="btn btn-primary"
                                                    target="_blank"
                                                >
                                                    Exportar
                                                </CSVLink>
                                            </Button>
                                        </div>)} */}
                                </Col>
                            </Row>

                            <div style={styles.baseVerticalMargin}>
                                <Card className={classes.tabContainer}>
                                    {!params.IsLoading ?
                                        <div>
                                            <Table
                                                id="table"
                                                rowKey={record => (record.idCommunication +'-'+ record.courseCode)}
                                                loading={params.isLoading}
                                                //rowKey={item => String(item.courseCode) /*item => String(item.idCommunication)*/}
                                                columns={params.cols}
                                                dataSource={params.listKardex /*params.communicationProgram.communicationStatus*/}
                                                onChange={params.handleTableChange}
                                                pagination={pagination}
                                                // scroll={{ x: 1800 }}
                                                scroll={{ x: 'min-content', y: (height - 500) }}
                                                size={"small"}
                                                rowSelection={rowSelection}

                                            />
                                        </div> : <div></div>}
                                </Card>
                            </div>
                        </div>
                        :
                        <div className={classes.example}>
                            <Spin tip="Cargando..." />
                        </div>
                }}
            </KardexContainer>
        </div>
    )
}